<template>
  <div>
    <!-- {{ data }} -->
    <!-- {{model}} -->
    <!-- {{data_object}} -->
    <v-form-card
      v-if="data_object"
      :data="data"
      ref="form"
      :key="formKey"
      :panels="true"
      :submit_button_caption="'Save'"
      :onGetData="onGetData"
      :setTableProperties="setTableProperties"
      :caption="caption"
    >
    </v-form-card>
  </div>
</template>

<script>
import Vue from "vue";
import VueAxios from "vue-axios";
import axios from "axios";
Vue.use(VueAxios, axios);

import * as fun from "../plugins/common";
// import * as charge from "../plugins/objects/charge";

export default {
  name: "Customer",
  components: {
    // VLoading: () => import("../components/Loading.vue"),
    // VPanels: () => import("../components/Panels.vue"),
    VFormCard: () => import("../components/FormCard.vue")
  },
  props: {},
  data() {
    return {
      object_name: "tariff_list",
      shipment_id: 0,
      caption: "Tariff Detail",
      data_object: {},
      data: null,
      expanded: [],
      formKey: 0,
      required: [],
      model: null,
      chargeCategory: [],
      chargeTable: [],
      transportation_base: ""
    };
  },

  mounted() {
    this._id = this.$route.params.id;
    this.data = {
      object_name: this.object_name,
      object_id: this._id,
      single_record: true,
      // qry: { _id: this._id },
      portal_id: this.$session.get("portal_id"),
      additional_data: [
        { obj_name: "company" },
        { obj_name: "charge_category" },
        { obj_name: "service_type" },
        { obj_name: "material_list" }
      ]
    };
    this.formKey = !this.formKey;
    this.$root.$on("routeChanged", function(obj) {
      if (obj == "tariff") {
        this.formKey = !this.formKey;
      }
    });
  },
  beforeDestroy() {},
  watch: {
    model: {
      handler: function(newValue, oldValue) {
        this.transportation_base = this.model.transportation_base;
      },

      deep: true
    },
    $route: {
      handler: function(newValue, oldValue) {
        // console.log(newValue);
        this.formKey = !this.formKey;
      }
    },
    transportation_base: {
      handler: function(newValue, oldValue) {
        console.log(this.transportation_base, oldValue, newValue);
        if (oldValue) {
          this.$refs.form.$refs.form.submit();
          this.formKey = !this.formKey;
          // this.$root.$emit("dataChanged", {
          //   objectName: "tblCharges",
          //   update: true,
          // });
          // var charges = fun.getChildByRef(this, "charges");
          // console.log(charges);
        }
      }
    }
  },
  methods: {
    onLoadComponent(obj) {
      console.log(obj);
    },
    onDataChanged(model, valid) {
      console.log(model, valid);
      this.model = model;
    },
    onGetData(data_object) {
      this.model = data_object.model;
      this.chargeCategory = this.model.charge_category;
      this.data_object = data_object;
      this.transportation_base = this.model.transportation_base;
      this.getDefaults();
      // if (!this.model.charges.length) {
      //   this.addDefaultCharges();
      // }
    },
    getDefaults() {
      if (!this.model.rate_types || !this.model.rate_types.length) {
        this.model.rate_types = [];
        this.model.rate_types.push({ rate_type: "regular" });
      }
      if (
        !this.model.rate_types.filter(r => {
          return r.rate_type == "regular";
        }).length
      ) {
        this.model.rate_types.splice(0, 0, { rate_type: "regular" });
      }
      if (!this.model.charges || !this.model.charges.length) {
        this.model.charges = [];
        // model.charge_category.forEach((c) => {
        //   var serviceType = table.filter((t) => {
        //     return t.charge_category_name == c.charge_category;
        //   });
        var chargeCategory = this.data_object.additional_model.charge_category.filter(
          c => {
            return (c.charge_category = this.model.charge_category);
          }
        )[0];
        switch (this.model.charge_category) {
          case "labor":
            for (let nmen = 2; nmen < 6; nmen++) {
              var labor = {
                charge_category: chargeCategory.charge_order.toString(),
                charge: {
                  men: nmen,
                  truck: 1,
                  max_weight: 500 * nmen,
                  max_stairs: (nmen - 2) * 3
                },
                unit_type: "hour",
                rate: {},
                // service_type: serviceType[0].service_type,
                _id: fun.guid()
              };
              this.model.charges.push(labor);
            }
            break;

          case "material":
            var materials = this.data_object.additional_model.material_list;
            var materialSpecific = ["container", "packing", "unpacking"];
            materials.forEach(m => {
              materialSpecific.forEach(s => {
                var material = {
                  charge_category: chargeCategory.charge_order.toString(),
                  charge: { item: m.material_name, specific: s },
                  unit_type: "unit",
                  rate: {},
                  // service_type: serviceType[0].service_type,
                  _id: fun.guid()
                };
                this.model.charges.push(material);
              });
            });

            break;

          case "accessorial":
            // this.model.charges.push();
            break;

          case "transportation":
            var line_haul = {
              charge_category: chargeCategory.charge_order.toString(),
              charge: { item: "line_haul" },
              unit_type: this.model.charge_base,
              rate: {},
              // service_type: serviceType[0].service_type,
              _id: fun.guid()
            };
            this.model.charges.push(line_haul);
            break;

          default:
            break;
        }
        // });
      }
    },
    // addDefaultCharges() {
    //   var that = this;
    //   var serviceTypes = this.data_object.additional_model.service_type;
    //   model.estimate["non-binding"].shipment_service.forEach((s) => {
    //     s.estimate_charges = [];
    //     var defaultCharges = serviceTypes.filter((t) => {
    //       return t.service_type == s.service_type;
    //     });
    //     defaultCharges.forEach((d) => {
    //       d.default_charges.forEach((c) => {
    //         s.estimate_charges.push({
    //           charge_category: c,
    //         });
    //       });
    //     });
    //   });
    // },
    setTableProperties(e, model, data_object) {
      console.log(model, data_object);
      var that = this;
      var charge_categorys = that.data_object.model.charge_category;
      var materials = that.data_object.additional_model.material_list;
      var defaultModel = {};
      var vBind =
        data_object.schema.properties.charges.table_properties.schema["v-bind"];
      switch (this.model.charge_category) {
        case "labor":
          defaultModel = {
            charge: {
              men: 0,
              truck: 0,
              max_weight: 0,
              max_stairs: 0
            }
          };
          break;

        case "material":
          defaultModel = {
            charge: {
              item: "",
              specific: ""
            }
          };
          break;

        default:
          defaultModel = {
            charge: {
              item: ""
            }
          };
          break;
      }
      vBind.defaultModel = defaultModel;
      // switch (e.object_type) {
      //   case "charges":
      //     this.chargeTable = [];

      //     // data_object.additional_model.charge_category.forEach((c) => {
      //     //   var c_type = charge_categorys.filter((t) => {
      //     //     return t.charge_category == c.charge_category;
      //     //   });
      //     //   var chargeName = c_type[0].charge_category;
      //     //   if (c_type[0].charge_category == "transportation") {
      //     //     chargeName =
      //     //       c_type[0].charge_category +
      //     //       "_" +
      //     //       that.model.transportation_base +
      //     //       "_base";
      //     //   }
      //     //   if (c_type.length)
      //     //     that.chargeTable.push({
      //     //       charge_category: c_type[0].charge_order.toString(),
      //     //       charge_category_name: chargeName,
      //     //       service_type: c.service_type,
      //     //       rate: { rate: 0 },
      //     //       // _id: fun.guid(),
      //     //     });
      //     // });
      //     e["v-bind"] = charge.getVBind(
      //       that.chargeTable,
      //       this.model,
      //       materials
      //     );
      //     break;

      //   default:
      //     break;
      // }
      if (e["v-bind"]) {
        e["v-bind"].data_object = {
          ...e["v-bind"].data_object,
          ...e.table_properties
        };
        e["v-bind"].data_object.model = this.model;
      }
    }
  }
};
</script>

<style lang="css" scoped>
/* html {
  overflow: hidden !important;
}

.v-card {
  display: flex !important;
  flex-direction: column;
}

.v-card__text {
  flex-grow: 1;
  overflow: auto;
} */
</style>
